/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Grid, Card, CardContent, Typography, Skeleton, Stack } from '@mui/material';
import Label from '../../../../components/label';
import { useBusinessUser } from '../../../../hooks';

export default function UserBusiness(props){
    const { user } = props;
    const { businessRelation, skeleting, FindRelationBusinessUser } = useBusinessUser();

    useEffect(() => {
        FindRelationBusinessUser(user?.id);
    }, []);

  return (
    <>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
                Empresas relacionadas
            </Typography>
        </Stack>
        {
            skeleting ? (
                <Grid container spacing={1}>
                    {
                        [1,2,3].map(
                            (item, index) => (
                                <Grid key={index} item xs={12} sm={4} md={4}>
                                    <Skeleton variant="rounded" width="100%" height={140} />
                                </Grid>
                            )
                        )
                    }
                </Grid>
            ):(
                <Grid container spacing={1}>
                    {
                        businessRelation.map(
                            (item, index) => (
                                <Grid key={index} item xs={12} sm={4} md={4}>
                                    <Card sx={{ minWidth: 275 }}>
                                        <CardContent>
                                            <Typography variant="body2">
                                                <Label style={{float: 'right'}} color={(item.business?.status === 1 ? 'success':'error')}>{(item.business?.status === 1 ? 'Activo':'Inactivo')}</Label>
                                            </Typography>
                                            <Typography variant="h5" component="div">
                                                {item.business.rfc}
                                            </Typography>
                                            <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                                {item.business.businessName}
                                            </Typography>
                                            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                No.Empleado: {item.codeEmploye}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )
                        )

                    }
                </Grid>
            )
        }
    </>
  )
}
